import * as types from "./types";
import axios from "axios";

export const showContactForm = (): types.ShowContactFormAction => {
    return {
        type: types.SHOW_CONTACT_FORM
    };
};

export const hideContactForm = (): types.HideContactFormAction => {
    return {
        type: types.HIDE_CONTACT_FORM
    };
};

export const sendMessage = (emailText: string, messageText: string): types.SendMessageAction => {
    axios.post("https://test-database-pablo.firebaseio.com/messages.json", {
        email: emailText,
        message: messageText
    });

    axios
        .post("https://pzoani-email-service.herokuapp.com/api/v1/email", {
            email: emailText,
            message: messageText
        })
        .then((response) => console.log(response))
        .catch((error) => console.log(error));

    return {
        type: types.SEND_MESSAGE,
        payload: {
            emailText: emailText,
            messageText: messageText
        }
    };
};

export const showContactConfirm = (): types.ShowContactConfirmAction => {
    return {
        type: types.SHOW_CONTACT_CONFIRM
    };
};

export const hideContactConfirm = (): types.HideContactConfirmAction => {
    return {
        type: types.HIDE_CONTACT_CONFIRM
    };
};
